<template>
  <div class="about history2">
    <h2 class="about-title">発展期<span class="about-title__year">1971-1980</span></h2>

    <div class="content1 section">
      <p>大阪万博で幕をあけた1970年代。モーターサイクルスポーツにとっても、飛躍の年代となることが期待されました。
        協会設立当初から開催されてきたロードレース、モトクロスの２競技に加え、1970年には第１回ジムカーナ大会を開催。さらに、1971年からは現在も冬のモータースポーツの王者として高い人気を得ているスノーモビルが「スノースクランブル」として正式にMFJの全日本選手権に加えられました。<br>
      さらに、1972年にはトライアル委員会が設置され、翌1973年には第１回全日本トライアル選手権が神奈川県の早戸川で開催されました。これにより、現在に続く主要３競技が確立されたこととなります。<br>
      また1970年には茨城県に筑波サーキットが、1975年にはスポーツランドSUGOが開場し、多くの愛好者の人気を集めました。</p>
    </div>
    
    <div class="content2 img-content">
      <div class="img-content__bg">
        <div class="img-content__wrap">
          <div class="img-content__text">
            <h3>スノーモービルが追加</h3>
            <p>1971年からMFJの全日本選手権に加わったスノーモビル。当時は「スノースクランブル」の名称で開催され、多くの愛好者が集った</p>
          </div>
          <Carousel :slides="slides"></Carousel>
        </div>
      </div>
    </div>
    
    <div class="content3 section">
      <div class="content3__wrap">
            <h3>オイルショック</h3>
            <p>しかし、1973年と1979年に起こった２度のオイルショックはモーターサイクルスポーツにも大きな影響を与えました。その中でも、全日本選手権を頂点とし、各競技は綿々と開催され続け、モーターサイクルスポーツの火をともし続けたのです。<br></p>
             <h3>日本人選手の活躍</h3>
             <p>そのような時代背景の中、モーターサイクルスポーツ愛好者を元気づけたのが、海外での日本人選手の活躍です。1970年代は本格的な海外進出が始まった年代ともいえ、海外での日本選手の活躍もめざましいものがありました。</p>
            <div class="img-wrapper">
              <figure>
                <img src="/img/1971-1980-1.jpg" alt="鈴鹿8時間耐久ロードレース">
                <figcaption>1978年から始まった鈴鹿8時間耐久ロードレースは高い人気を集め、国内外から有力選手がこぞってエントリーした。
                1980年からはFIM世界選手権の一戦として開催されることとなる。</figcaption>
              </figure>
              <figure>
                <img src="/img/1971-1980-2.jpg" alt="片山敬済の世界チャンピオン獲得">
                <figcaption>日本のモーターサイクルスポーツ史に輝く片山敬済の世界チャンピオン獲得。1977年、片山選手はロードレース世界選手権GP350クラスで日本人初の世界チャンピオンに輝いた</figcaption>
              </figure>
            </div>
          <p>1972年には金谷秀夫選手が、ロードレース世界選手権西ドイツGP250ccクラスで優勝。モトクロスでは1973年のFIM杯125ccクラスで、鈴木都良夫選手が、Aグループのチャンピオンに輝いています。<br>
          そして1977年、ロードレースの世界世界選手権350ccクラスで片山敬済選手が日本人初のシリーズチャンピオンを獲得、さらに1978年にはモトクロス世界選手権125ccクラスで渡辺明選手がチャンピオンに輝くなど、ロードレース、モトクロスの両競技で世界の頂点を極めることとなるのです。<br>
          また、この1978年には第１回鈴鹿８時間耐久ロードレースが開催され、1980年にはFIM世界選手権に格上げされます。</p>
      </div>
    </div>

    <div class="content4 section">
      <h3>女性だけのレースを初開催</h3>
      <p>普及活動では、ロードレースの日本グランプリで女性だけのレースを初開催し、多くの参加を集めました。さらに1979年からは世界選手権レース観戦招待などを目玉とした「MFJ10万人キャンペーン」や会員へのサービス活動活発化を図る「MFJ活動協賛サークル」制度なども創設し、さらなる飛躍へと備えたのです。</p>
    </div>

    <div class="content5 img-content">
      <div class="img-content__bg">
        <div class="img-content__wrap">
          <div class="img-content__text">
            <h3>モトクロスで世界チャンピオン</h3>
            <p>ロードレースに遅れることわずか１年。１９７８年にはモトクロス世界選手権１２５CCクラスで渡辺明選手が世界チャンピオンを獲得。<br>モトクロスでの日本人世界チャンピオンは未だに渡辺選手唯一人だ。</p>
          </div>
          <img src="/img/about-1970_04.jpg" alt="">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Carousel from '@/components/Carousel';
export default {
  name: "tab1964",
  components: {
    Carousel,
  },
  data: () => {
      return {
        slides: [
            {url: '/img/about-1970_01.jpg', alt: 'img1'},
            {url: '/img/about-1970_01_2.jpg', alt: 'img2'},
            {url: '/img/about-1970_01_3.jpg', alt: 'img3'},
            {url: '/img/about-1970_01_4.jpg', alt: 'img4'}
        ],
      }
  },
};
</script>

<style lang="scss">
.history2 {
  figure {
    margin: 0;
    padding: 0;
  }
  figcaption {
    font-size: 12px;
    margin-top: 10px;
  }
  .content2{
    background: url(/img/about-1970_01_back.jpg) center center / cover no-repeat;
  }
  .column {
    display: flex;
    justify-content: flex-start;
    > * {
      width: 48%;
    }
    > *:first-child {
      margin-right: 2%;
    }
    @media(max-width: 1200px) {
      display: block;
      > * {
        width: 100%;
      }
      > *:first-child {
        margin-right: 0;
        margin-bottom: 20px;
      }
    }
  }
  .content2 {
    margin: 40px 0;
  }
  .content3 {
    h3 {
      margin: 30px 0 0;
    }
    .img-wrapper {
      display: flex;
      justify-content: space-between;
      margin: 20px 0;
      figure {
        width: auto;
        padding: 15px;
        border: 1px solid #ccc;
        text-align: center;
        &:first-child {
          margin-right: 20px;
        }
      }
      @media (max-width: 900px) {
        display: block;
        figure {
          margin: 0 0 15px;
          width: 100%;
        }
      }
    }
    figcaption {
      text-align: left;
    }
  }
  .content4 {
    margin: 40px auto;
    h3 {
      margin-bottom: 15px;
    }
    p {
      margin: 0;
    }
  }
  .content5 {
    background: url('/img/about-1970_04.jpg') center center / cover no-repeat;
    .img-content__wrap {
      @media(min-width:768px){
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .img-content__text{
          width: calc(100% - 350px);
        }
        img{
          width: 320px;
        }
      }
    }
  }
}
</style>